let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("13Iw6")).then(() => parcelRequire('4QGzD'));